import * as React from "react";
import {useContext} from "react";


//css
import {GeneralContext} from "../FSARequestLicenseContext";
import GenericChart from "./GenericChart";
import {budgetKey, mainMessages} from "../../../assets/text/MultilingualText";
import UserContext from "../../common/UserContext";
import {useLocalization} from "@progress/kendo-react-intl";




const BudgetChart = (props) => {
    const {
        headerInfo,
    } = useContext(GeneralContext);

    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const {
        hidden = false
    } = props

    const localization = useLocalization();

    const {
        budget,
        consumed,
        cart,
        available,
        agreement,
        start_date,
        end_date,
        currency_code,
        currency_locale,
    } = headerInfo;

    const data = [
        {
            "category": "consumed",
            "value": consumed,
            "backgroundColor": "#432668",
            "fontColor": "#FFFFFF",
        },
        {
            "category": "selected",
            "value": cart,
            "backgroundColor": "#A895B5",
            "fontColor": "#000000",
        },
        {
            "category": "available",
            "value": available,
            "backgroundColor": "#FFFFFF",
            "fontColor": "#000000",
        }
    ]

    let style = {}
    if(hidden){
        style = {
            visibility: "hidden",
            maxHeight: 0
        }
    }

    return (
        <div style={style}>
            <GenericChart
                total={budget}
                title={agreement}
                budget_name={localization.toLanguageString(budgetKey, mainMessages[siteLanguageDefault][budgetKey])}
                start_date={start_date}
                end_date={end_date}
                currency_code={currency_code}
                currency_locale={currency_locale}
                data={data}
            />
        </div>
    )
};

export default BudgetChart;